var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

$(window).on('load' , function() {

  setTimeout(function(){$('.sw-Ttl').addClass("is-animated");},0);
  setTimeout(function(){$('.st-Lower_Contents').addClass("is-animated");},600);

});



// WEBPACK FOOTER //
// ./src/morfonica-anime_v0/assets/js/common/script.js